import { useGame } from "../../data/gameContext";
import { TTown } from "../../data/town";
import { AreSameLocation as AreSameLocation, calcDistance } from "./mapGenerator";
import { TDisplayMapTile } from "./mapTypes";

interface ITownPopoverProps {
    tile: TDisplayMapTile;
}

export default function TownPopover(props: ITownPopoverProps) {
    const { gameState, updateGameState } = useGame() 
    const travelTime = Math.ceil(calcDistance(gameState.PlayerCharacter!.Location, gameState.GameTowns[props.tile.TownIndex!].Location));
    // the player can only travel to a town if the travel time is less than the horse's stamina and water
    const canTravel = gameState.Horse.Stamina > travelTime && gameState.Horse.Water > travelTime;
    const town: (TTown|undefined) = props.tile.TownIndex !== undefined && gameState.GameTowns.length > props.tile.TownIndex ? gameState.GameTowns[props.tile.TownIndex] : undefined

    function handlePlayerTravel(town:TTown) {
        const travelTime = Math.ceil(
            calcDistance(
                gameState.PlayerCharacter!.Location, town.Location
            )
        );

        // if the direction of travel is east, set the horse to face east, otherwise set it to face west
        const horseEast = gameState.PlayerCharacter!.Location.x < town.Location.x;

        updateGameState({
            PlayerCharacter: {
                ...gameState.PlayerCharacter!,
                TravelTo: {...town.Location},
                TravelTimeLeft: travelTime,
            },
            Phase: "travelling",
            Horse: {
                ...gameState.Horse,
                TiedUp: false,
                Feeding: false,
                East: horseEast,
            }
        });
    }
    
    return (
        <div className="town-popover-container">
            <div>🏫</div>
            {town && (
            <div className="town-popover">
                <h3>{`Town: ${town.Name}`}</h3>
                <p>{town.Description}</p>
                <p>Size: {town.Size}</p>
                <p>
                {gameState.PlayerCharacter 
                    ? `Travel time: ${travelTime}`
                    : "Travel time: N/A"}
                </p>
                {gameState.PlayerCharacter && !AreSameLocation(gameState.PlayerCharacter.Location, town.Location) && canTravel &&
                <button onClick={() => handlePlayerTravel(town)}>Travel to</button>}
            </div>
            )}
        </div>
    )
}